import './SignUpLogo.scss';
import logo from '../../assets/images/logo_empiria.png';

export const SignUpLogo = () => (
    <div className='content_wrapper'>
        <img src={logo} alt="LOGO" className='logo' />
    </div>
);